import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { replaceByElement } from "../../../../../utils/Logs";

interface IProps {
  employee: string;
  employeeId: string;
}

export default function EmployeeCreated(props: IProps) {
  const { employee, employeeId } = props;
  const { t } = useTranslation();

  const employeeName = useMemo(
    () => employee ?? employeeId,
    [employee, employeeId]
  );

  return useMemo(
    () =>
      replaceByElement(
        t("log.employee_was_created"),
        "{employee}",
        employeeName
      ),
    [employeeName, t]
  );
}
